<div class="p-6 border-b border-outline-variant/30 flex items-center justify-between">
  <a routerLink="/dashboard" class="flex items-center gap-3">
    <app-logo-mark [size]="36" />
    <div>
      <h1 class="text-headline-sm font-headline-sm font-bold text-primary leading-none">VendIA</h1>
      <p class="font-label-sm text-label-sm text-on-surface-variant mt-0.5">Admin Panel</p>
    </div>
  </a>
  @if (closable()) {
    <button
      type="button"
      class="md:hidden p-1 text-on-surface-variant hover:text-primary"
      aria-label="Cerrar menú"
      (click)="closeRequested.emit()"
    >
      <span class="material-symbols-outlined">close</span>
    </button>
  }
</div>

<div class="flex-1 overflow-y-auto py-3 flex flex-col gap-1 px-2">
  @for (item of navItems(); track item.key) {
    <a
      [routerLink]="item.route"
      routerLinkActive
      #rla="routerLinkActive"
      [attr.data-testid]="'nav-item-' + item.key"
      [class]="
        rla.isActive
          ? 'flex items-center gap-3 px-4 py-3 text-primary font-bold bg-secondary-container/10 border-r-4 border-primary scale-[0.99] transition-transform'
          : 'flex items-center gap-3 px-4 py-3 text-on-surface-variant hover:text-primary hover:bg-surface-container transition-colors duration-200 rounded-lg'
      "
    >
      <span class="material-symbols-outlined" [style.font-variation-settings]="rla.isActive ? '\'FILL\' 1' : null">{{ item.icon }}</span>
      <span class="font-label-md text-label-md">{{ item.label }}</span>
    </a>
  }
</div>

<div class="p-4 border-t border-outline-variant/30">
  <button
    type="button"
    class="w-full flex items-center gap-3 px-4 py-3 text-on-surface-variant hover:text-error hover:bg-error-container/20 rounded-lg transition-colors"
    (click)="logout()"
  >
    <span class="material-symbols-outlined">logout</span>
    <span class="font-label-md text-label-md">Cerrar Sesión</span>
  </button>
</div>
